"use client";
import "./index.scss";
import React from "react";
import { useState } from "react";
import { displayValue, StatusComponent } from "../OtherBetsDropdown";
import "../OtherBetsDropdown/index.scss";
import ICON_ARROW_DOWN_MOBILE_BLACK from "@/assets/images/Arrow_drop_down.svg";

const TotalCornersOdds = ({ totalCornersOdds }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <div className="total-corners-odds-wrapper">
      <div className="bg-[var(--theme-bg)] flex justify-between items-center @xs:h-5 @xs:w-full rounded-t-sm @lg:h-[2rem] @lg:mb-1 @lg:py-1 @lg:rounded-md">
        <div
          className="flex flex-wrap items-center gap-1 hover:cursor-pointer"
          onClick={() => handleCollapse()}
        >
          <>
            <img
              alt="Net88"
              src={ICON_ARROW_DOWN_MOBILE_BLACK}
              width={20}
              height={20}
              className={`w-6 h-6 transition-transform duration-300 ${isCollapsed ? "rotate-180" : ""}`}
            />
          </>
          <span className="font-semibold text-sm text-[var(--theme-text)] w-[7.75rem]">
            Tổng Phạt Góc
          </span>
        </div>
      </div>
      <div
        id="collapse"
        className={`bg-white rounded-br-lg rounded-bl-lg ${
          isCollapsed ? "hidden" : "visible"
        }`}
      >
        <div className="max-h-[250px] overflow-auto">
          <div className="total-corners-odds-container">
            {Array.isArray(totalCornersOdds) && totalCornersOdds.map((item, index) => (
              <div key={index} className="total-corners-odds-item">
                <p className="col-span-4 text-xxs rounded-[25px] bg-[var(--theme-foreground)]">
                  {displayValue(item?.totalCorners)}
                </p>
                <div className="col-span-4 flex items-center justify-center">
                  <p className="text-xxs flex-1 font-semibold">Tài</p>
                  <p className="flex flex-1 items-center justify-center gap-1 inline-block bg-[var(--theme-foreground)] text-xxs w-[82px] py-[1px] rounded-[25px] text-center h-[20px]">
                    {displayValue(item?.over)}
                    <StatusComponent trend={item?.initialOverTrend} />
                  </p>
                </div>

                <div className="col-span-4 flex items-center justify-center">
                  <p className="text-xxs flex-1 font-semibold">Xỉu</p>
                  <p className="flex flex-1 items-center justify-center gap-1 inline-block bg-[var(--theme-foreground)] text-xxs w-[82px] py-[1px] rounded-[25px] text-center h-[20px]">
                    {displayValue(item?.under)}
                    <StatusComponent trend={item?.initialUnderTrend} />
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(TotalCornersOdds);